export const messages = {
  statusRequired:`status is required`,
  passwordOneUppercase: `The Password must contain at least one uppercase character`,
  passwordOneLowercase: `The Password must contain at least one lowercase character`,
  passwordOneNumeric: `The password must contain at least one numerical character.`,
  passwordRequired: 'Password is required',
  passwordLengthMin: 'Password must be at least 6 characters',
  passwordLengthMax: `Password can't be more than 32 characters`,
  newPasswordRequired: 'New Password is required',
  newPasswordLength: 'New Password must be at least 6 characters',
  confirmPasswordRequired: 'Confirm Password is required',
  passwordsDidNotMatch: "Passwords don't match",
  nameIsRequired: 'Name is required',
  firstNameRequired: 'First name is required',
  phoneNumberIsRequired: 'Phone Number is required',
  customerNameIsRequired: 'Customer name is required',
  lastNameRequired: 'Last name is required',
  streetIsRequired: 'Street Address is required',
  emailIsRequired: 'Email address is required',
  invalidEmail: 'Invalid email address',
  roleIsRequired: 'Role is required',
  permissionIsRequired: 'Permission is required',
  teamIsRequired: 'New member must be assigned to a team',
  productNameIsRequired: 'Product name is required',
  productTypeIsRequired: 'Product type is required',
  productSkuIsRequired: 'Product SKU is required',
  productCategoryIsRequired: 'Product Category is required',
  // productSubCategoryIsRequired: 'Product SubCategory is required',
  productDisIsRequired: 'Product Description is required',
  productAboutIsRequired: 'Product About is required',
  productImageIsRequired:'Product Image is required',
  productUrlIsRequired:'Product URL is required',
  pageTitlRequired:'Page Title is required',
  metaKeywordsRequired:'Meta Keywords required',
  metaDescriptionRequired:'Meta Description required',
  priceIsRequired: 'Product price is required',
  retailPriceIsRequired: 'Retail price is required',
  costPriceIsRequired: 'Purchase price is required',
  taxesAndChargesIsRequired: 'Taxes and Charges are required',
  taxesOptionsIsRequired: 'Tax options are required',
  stockLevelIsRequired: 'Current Stock Level cannot be negative',
  lowstockLevelIsRequired:'Low Stock Level cannot be negative',
  tradeNumberlIsRequired:'Trade Number is required',
  manufacturerNumberIsRequired:'Manufacturer Number is required',
  brandNameIsRequired: 'Brand Name is required',
  upcEantsRequired: 'UPC/EAN is required',
  unitNameIsRequired: 'Unit is required',
  salePriceIsRequired: 'Sale price is required',
  shippingPriceIsRequired: 'Shipping price is required',
  orderIdIsRequired: "Order ID is required.",
  statusIsRequired: "status is required.",
  totalPriceIsRequired: "Total price is required.",
  totalItemsIsRequired: "Total items count is required.",
  paymentStatusIsRequired: "Payment status is required.",
  orderDateIsRequired: "Order date is required.",
  paymentMethodIsRequired: "Payment method is required.",
  shippingMethodIsRequired: "Shipping method is required.",
  cityIsRequired: 'City is required',
  stateIsRequired: 'State is required',
  countryIsRequired: 'Country is required',
  addressLineOneRequired: 'Address line 1 is required',
  zipCodeRequired: 'ZIP code is required',
  cardHolderNameIsRequired: 'Card holder name is required',
  cardNumberIsRequired: 'Card Number is required',
  cardExpireIsRequired: 'Expire Date is required',
  cvcNumberIsRequired: 'CVC Number is required',
  catNameIsRequired: 'Category name is required',
  subcatNameIsRequired: 'Sub Category name is required',
  parentcatNameIsRequired: 'Parent name is required',
  catNameIsDescription: 'Description is required',
  slugIsRequired: 'Slug is required',
  addressIsRequired: 'Address is required',
  createDateIsRequired: 'Create Date is required',
  dueDateIsRequired: 'Due Date is required',
  discountIsRequired: 'Discount amount is required',
  taxIsRequired: 'Tax amount is required',
  itemNameIsRequired: 'Item Name is required',
  itemDescIsRequired: 'Item Description is required',
  itemQtyIsRequired: 'Item Quantity is required',
  itemPriceIsRequired: 'Item Price is required',
  fullNameIsRequired: 'Full name is required',
  propertyTypeIsRequired: 'Property type is required',
  placeTypeIsRequired: 'Place type is required',
  amenitiesAreRequired: 'Amenities are required',
  thisFieldIsRequired: 'This Field is required',
  propertyNameIsRequired: 'Property name is required',
  snippetNameIsRequired: 'Snippet name is required',
  snippetDirIsRequired: 'You must have to select a snippet folder',
  templateNameIsRequired: 'Template name is required',
  templateDirIsRequired: 'You must have to select a template folder',
  folderNameIsRequired: 'Folder name is required',
  folderNameLengthMin: 'Folder name must be at least 3 letters',
  productColorRequired: 'Product Color is Required',
  productSizeRequired: 'Product Size is Required',
  descriptionIsRequired: 'Description is Required',
  locationIsRequired: 'Location is Required',
  startDateIsRequired: 'Start Date is required',
  startTimeIsRequired: 'Start Time is required',
  endDateIsRequired: 'End Date is required',
  endTimeIsRequired: 'End Time is required',
  roleNameIsRequired: 'Role Name is Required',
  roleNameLengthMin: 'Role name must be at least 3 letters',
  emailRequired: 'Email is Required',
  mobileRequired: 'Mobile Number is Required',
  stateRequired: 'State is Required',
  cityRequired: 'City is Required',
  zipRequired: 'ZIP Code is Required',
  addressRequired: 'Address is Required',
  productIsRequired: 'Product ID is required.',
  bannerTypeIsRequired: 'Banner type is required.',
  storyTypeIsRequired: 'Story type is required.',
  invalidBannerUrl: 'Invalid banner URL.',
  invalidStoryUrl: 'Invalid Story URL.',
  bannerUrlIsRequired: 'Banner URL is required.',
  StoryUrlIsRequired: 'Story URL is required.',
  resoureTypeIsRequired: 'Resource type is required.',
  statusInvalid: 'Status must be a valid number (0 or 1).',
  resourceTypeIsRequired: 'Resource type is required.',
  // discountProductIsRequired: "Discount product is required.",
  couponCodeIsRequired: "Coupon code is required.",
  couponTypeIsRequired: "Coupon type is required.",
  discountValueMustBePositive: "Discount value must be a positive number.",
  usageLimitMustBePositive: "Usage limit must be a positive integer.",
  activeStatusIsRequired: "Active status is required.",
  imageSizeTooLarge: "The image size must be less than 5MB.",
  invalidImageType: "Only JPG and PNG image formats are supported.",
  titleIsRequired: "Payment title is required.",
  apiKeyIsRequired: "API Key is required.",
  secretKeyIsRequired: "Secret Key is required.",
  modeIsRequired: "Mode is required.",
  modeInvalid: "Mode must be either 'Test' or 'Live'.",
  imageIsRequired: "Please upload a logo image.",
};
